// extracted by mini-css-extract-plugin
export default {"icon":"_42a92ad3"};